import { render, staticRenderFns } from "./CoozzyListIcon.vue?vue&type=template&id=357d930a&scoped=true"
import script from "./CoozzyListIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyListIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyListIcon.vue?vue&type=style&index=0&id=357d930a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357d930a",
  null
  
)

export default component.exports